export function ErrorBanner({ message, onDismiss }: { message: string; onDismiss?: () => void }): JSX.Element {
  return (
    <div className="banner banner-error" role="alert" data-testid="error-banner">
      <span className="banner-icon" aria-hidden="true">
        ⚠
      </span>
      <span className="banner-message">{message}</span>
      {onDismiss && (
        <button type="button" className="banner-dismiss" onClick={onDismiss} aria-label="Dismiss error">
          <span aria-hidden="true">&times;</span>
        </button>
      )}
    </div>
  );
}
